import { DrawerContainer } from "components/DrawerContainer";
import React, { useEffect } from "react";
import { Outlet, Navigate, useSearchParams } from "react-router-dom";

export const PrivateRoute = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const token = localStorage.getItem("token");

  useEffect(() => {
    const token = searchParams.get("token");

    if (token) {
      localStorage.setItem("token", token);
      setSearchParams([]);
    } else {
    }
  }, [searchParams, setSearchParams]);

  return token ? (
    <DrawerContainer>
      <>
        <Outlet />
      </>
    </DrawerContainer>
  ) : (
    <>
      <Navigate to="/" />
    </>
  );
};
